import { Pipe, PipeTransform } from "@angular/core"

export interface IConditionTextSegment {
  text: string
  bold: boolean
}

// the saved condition text is a flat string, but the reader needs the lead-in
// ("Hidden if:") and the AND/OR joiners emphasised the same way the dialog summary does
@Pipe({
  name: "conditionTextSegments",
  standalone: false,
})
export class ConditionTextSegmentsPipe implements PipeTransform {
  transform(conditionText: string): IConditionTextSegment[] {
    if (!conditionText) return []

    const { leadIn, body } = this.splitLeadIn(conditionText)
    const segments: IConditionTextSegment[] = []

    if (leadIn) segments.push({ text: leadIn, bold: true })
    segments.push(...this.splitJoiners(body))

    return segments.filter((segment) => segment.text.length > 0)
  }

  // only the first colon separates the lead-in; a value later in the text may contain one
  private splitLeadIn(conditionText: string): { leadIn: string; body: string } {
    const colonIndex = conditionText.indexOf(":")
    if (colonIndex === -1) return { leadIn: "", body: conditionText }

    return {
      leadIn: conditionText.slice(0, colonIndex + 1),
      body: conditionText.slice(colonIndex + 1),
    }
  }

  // generated joiners are always space-delimited, so requiring the surrounding spaces
  // avoids bolding an all-caps AND/OR that a user typed inside a value
  private splitJoiners(body: string): IConditionTextSegment[] {
    return body.split(/ (AND|OR) /).map((part, index) => (index % 2 === 1 ? { text: ` ${part} `, bold: true } : { text: part, bold: false }))
  }
}
